const initModalPDF = () => {
    const modalPDFList = document.querySelectorAll("[data-modal-pdf]");
    if (modalPDFList && modalPDFList.length > 0) {
        modalPDFList.forEach((modalPDF, index) => {
            const downloadCTA = modalPDF.querySelector("[data-pdf-cta]");
            const modalDownload = modalPDF.querySelector("[data-modal-download]");
            if (downloadCTA && modalDownload) {
                const closeModalDownload = modalDownload.querySelector("[data-close-modal-download]");
                const form = modalDownload.querySelector("form");
                if (form) {
                    const inputList = form.querySelectorAll("input");
                    inputList.forEach((input) => {
                        if (input.name !== "__RequestVerificationToken") {
                            input.id = `${input.id}${index}`; // Add index to id attribute
                        }
                    });
                    const labelList = form.querySelectorAll("label");
                    labelList.forEach((label) => {
                        label.setAttribute("for", `${label.getAttribute("for")}${index}`);
                    });
                }
                downloadCTA.addEventListener("click", (e) => {
                    e.preventDefault();
                    window.scrollBy(0, 1);
                    modalDownload.classList.add("active");
                });
                closeModalDownload.addEventListener("click", () => {
                    modalDownload.classList.remove("active");
                });
            }
        });
    }
};
